/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgDisclosure } from '../../models/esg-disclosure';
import { EsgDisclosureFieldsFilter } from '../../models/esg-disclosure-fields-filter';
import { EsgFramework } from '../../models/esg-framework';

export interface DisclosuresByProfileByFrameworkByLatestYearList$Params {
  profileId: number;
  framework: EsgFramework;
  includeFields?: Array<EsgDisclosureFieldsFilter>;
}

export function disclosuresByProfileByFrameworkByLatestYearList(http: HttpClient, rootUrl: string, params: DisclosuresByProfileByFrameworkByLatestYearList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EsgDisclosure>>> {
  const rb = new RequestBuilder(rootUrl, disclosuresByProfileByFrameworkByLatestYearList.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('framework', params.framework, {});
    rb.query('includeFields', params.includeFields, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EsgDisclosure>>;
    })
  );
}

disclosuresByProfileByFrameworkByLatestYearList.PATH = '/esg/profile/{profileId}/esg/framework/{framework}/year';
